import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Hand, X } from 'lucide-react'

const STORAGE_KEY = 'venetiae_onboarding_dismissed'

/**
 * Banner di benvenuto mostrato in cima alla dashboard al primo accesso.
 * Dismissibile; la scelta è ricordata in localStorage (UX-001).
 */
export default function OnboardingBanner() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === '1',
  )

  if (dismissed) return null

  const close = () => {
    localStorage.setItem(STORAGE_KEY, '1')
    setDismissed(true)
  }

  return (
    <div className="mx-8 mt-6 bg-brand-50 border border-brand-200 rounded-lg p-4 relative">
      <button
        onClick={close}
        aria-label="Chiudi"
        className="absolute top-3 right-3 text-brand-400 hover:text-brand-600"
      >
        <X size={18} aria-hidden="true" />
      </button>
      <h3 className="text-sm font-semibold text-brand-900 mb-1 flex items-center gap-2">
        <Hand size={16} aria-hidden="true" />
        Benvenuto in Venetiae Gestionale
      </h3>
      <p className="text-sm text-brand-800 mb-2">
        Per iniziare, segui questi passi:
      </p>
      <ol className="text-sm text-brand-800 list-decimal list-inside space-y-0.5">
        <li>
          Aggiungi un <Link to="/clients" className="underline font-medium">cliente</Link>
        </li>
        <li>
          Crea un <Link to="/projects/new" className="underline font-medium">progetto</Link> e
          il relativo <Link to="/estimates/new" className="underline font-medium">preventivo</Link>
        </li>
        <li>
          Registra le <Link to="/timesheets/new" className="underline font-medium">ore</Link> di
          lavoro
        </li>
      </ol>
    </div>
  )
}
